import { Link } from 'react-router-dom';
import { Eye, EyeOff, Send, Flame, CheckCircle2, Activity } from 'lucide-react';
import { timeAgo, trackingState } from '@/lib/tracking';

const LINE = {
  unsent: { Icon: Send, cls: 'text-slate-400', text: () => 'Not sent to the customer yet' },
  unseen: { Icon: EyeOff, cls: 'text-amber-600', text: (p) => `Sent ${timeAgo(p.share_sent_at || p.status_updated_at)} · not opened yet` },
  seen: { Icon: Eye, cls: 'text-emerald-700', text: (p) => `Seen ${p.share_views}× · last ${timeAgo(p.share_last_viewed_at)}` },
  hot: { Icon: Flame, cls: 'text-brand', text: (p) => `Hot lead · seen ${p.share_views}× · last ${timeAgo(p.share_last_viewed_at)}` },
  decided: { Icon: CheckCircle2, cls: 'text-slate-500', text: (p) => (p.share_views ? `Seen ${p.share_views}× before deciding` : 'Decision recorded') },
};

export function TrackingLine({ p }) {
  const st = trackingState(p);
  const { Icon, cls, text } = LINE[st];
  return (
    <p className={`text-xs font-medium flex items-center gap-1.5 ${cls}`} data-testid={`dash-tracking-${p.id}`} data-state={st}>
      <Icon size={13} /> {text(p)}
    </p>
  );
}

export function RecentActivity({ projects }) {
  const recent = projects
    .filter((p) => p.share_last_viewed_at && trackingState(p) !== 'decided')
    .sort((a, b) => b.share_last_viewed_at.localeCompare(a.share_last_viewed_at))
    .slice(0, 5);
  if (!recent.length) return null;
  return (
    <section className="tm-card p-5 mb-6" data-testid="dash-recent-activity">
      <p className="tm-label flex items-center gap-1.5"><Activity size={13} /> Recent customer activity</p>
      <ul className="divide-y divide-slate-100">
        {recent.map((p) => {
          const st = trackingState(p);
          return (
            <li key={p.id} className="py-2.5 flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-3 text-sm" data-testid={`dash-activity-${p.id}`}>
              <span className="flex items-start sm:items-center gap-2 min-w-0">
                {st === 'hot' ? <Flame size={15} className="text-brand shrink-0" /> : <Eye size={15} className="text-slate-400 shrink-0" />}
                <span className="sm:truncate">
                  <span className="font-semibold">{p.customer_name || 'Customer'}</span> viewed <span className="text-slate-600">{p.name}</span>
                  <span className="text-slate-400"> · {p.share_views}× total</span>
                </span>
              </span>
              <span className="flex items-center gap-3 shrink-0 pl-6 sm:pl-0">
                <span className="text-xs text-slate-500">{timeAgo(p.share_last_viewed_at)}</span>
                <Link to={`/estimator/${p.id}`} className="text-xs font-semibold text-brand hover:underline" data-testid={`dash-activity-open-${p.id}`}>Open</Link>
              </span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
